import { render, staticRenderFns } from "./post-graduate-detail.vue?vue&type=template&id=2229cb97"
import script from "./post-graduate-detail.vue?vue&type=script&lang=js"
export * from "./post-graduate-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports